(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$("#site-navigation"),
        menu_toggle: $973b254601fecd3f$var$$(".menu-toggle"),
        body: $973b254601fecd3f$var$$("body"),
        menu: undefined,
        links: undefined,
        sub_menus: undefined
    },
    vars: {
        activated_screen_resolution: 1199,
        show_arrows_on_desktop: false
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find("ul").eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find("a");
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find("ul");
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find("li.menu-item-has-children");
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find(".arrow-toggle").length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$("<span class='arrow-toggle'><span class='arrow-toggle--icon'></span></span>");
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on("click", function() {
                    $973b254601fecd3f$var$$($parent).toggleClass("expandeds");
                    $973b254601fecd3f$var$$($parent).find("> .sub-menu").slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$(".arrow-toggle").remove();
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on("click", function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass("toggled");
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr("href") != "#" && $973b254601fecd3f$var$$(this).attr("href") != "") {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.container.removeClass("toggled");
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on("resize", function() {
            $973b254601fecd3f$var$Menu.appendArrows();
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.$dom.container.find("> div").click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]')
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $538ea2323a48fb5c$var$$ = jQuery;
const $538ea2323a48fb5c$var$Slider = {
    init: function() {
        $538ea2323a48fb5c$var$$(document).ready(function() {
            $538ea2323a48fb5c$var$$(".section-hero").slick({
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                infinite: true
            });
            $538ea2323a48fb5c$var$$(".testimonials-items").slick({
                arrows: true,
                dots: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                prevArrow: '<div class="arrow prev-arrow"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" transform="matrix(-1 0 0 1 48 0)" fill="white"/><path d="M24.3483 18.0788L18.7754 24.3483M18.7754 24.3483L24.3483 29.9212M18.7754 24.3483H29.2246" stroke="#513933" stroke-width="1.4"/></svg></div>',
                nextArrow: '<div class="arrow next-arrow"><svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" transform="translate(0.550781)" fill="white"/><path d="M24.2025 18.0788L29.7754 24.3483M29.7754 24.3483L24.2025 29.9212M29.7754 24.3483H19.3262" stroke="#513933" stroke-width="1.4"/></svg></div>',
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });
    }
};
var $538ea2323a48fb5c$export$2e2bcd8739ae039 = $538ea2323a48fb5c$var$Slider;


const $8bae1bbaa0bec04d$var$$ = jQuery;
const $8bae1bbaa0bec04d$var$ToTopButton = {
    init: function() {
        this.toTopBtn = document.getElementById("toTopBtn");
        this.setupScrollListener();
        this.setupClickListener();
    },
    setupScrollListener: function() {
        window.onscroll = (function() {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) this.toTopBtn.style.display = "block";
            else this.toTopBtn.style.display = "none";
        }).bind(this); // Binding 'this' da bismo koristili 'toTopBtn' unutar funkcije
    },
    setupClickListener: function() {
        this.toTopBtn.addEventListener("click", function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
};
var $8bae1bbaa0bec04d$export$2e2bcd8739ae039 = $8bae1bbaa0bec04d$var$ToTopButton;


const $746bb6da1b444b48$var$$ = jQuery;
const $746bb6da1b444b48$var$Faq = {
    init: function() {
        const firstItem = $746bb6da1b444b48$var$$(".faq").first();
        const firstContent = firstItem.find(".answer");
        firstItem.addClass("active");
        firstContent.slideDown();
        $746bb6da1b444b48$var$$(".question").on("click", (e)=>{
            const parent = $746bb6da1b444b48$var$$(e.target).closest(".faq");
            const content = parent.find(".answer");
            const activeItem = $746bb6da1b444b48$var$$(".faq.active");
            if (!parent.hasClass("active")) {
                if (activeItem.length > 0) {
                    const activeContent = activeItem.find(".answer");
                    activeContent.slideUp();
                    activeItem.removeClass("active");
                }
                content.slideDown();
                parent.addClass("active");
            }
        });
        $746bb6da1b444b48$var$$(".faq-shop--question").on("click", (e)=>{
            const parent = $746bb6da1b444b48$var$$(e.target).closest(".faq-shop-item");
            const content = parent.find(".faq-shop--answer");
            const activeItem = $746bb6da1b444b48$var$$(".faq-shop-item.active");
            if (!parent.hasClass("active")) {
                if (activeItem.length > 0) {
                    const activeContent = activeItem.find(".faq-shop--answer");
                    activeContent.slideUp();
                    activeItem.removeClass("active");
                }
                content.slideDown();
                parent.addClass("active");
            } else {
                content.slideUp();
                parent.removeClass("active");
            }
        });
    }
};
var $746bb6da1b444b48$export$2e2bcd8739ae039 = $746bb6da1b444b48$var$Faq;


const $75ea841c346a0052$var$$ = jQuery;
const $75ea841c346a0052$var$InputNumber = {
    var: {
        min: 0,
        max: null,
        step: 1
    },
    dom: {
        inputs: $75ea841c346a0052$var$$('input[type="number"]')
    },
    increase: ($input)=>{
        const currentVal = parseFloat($input.val());
        const newValue = currentVal + $75ea841c346a0052$var$InputNumber.var.step;
        if ($75ea841c346a0052$var$InputNumber.var.max != null && newValue <= $75ea841c346a0052$var$InputNumber.var.max || $75ea841c346a0052$var$InputNumber.var.max == null) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    decrease: ($input)=>{
        const currentVal = parseFloat($input.val());
        const newValue = currentVal - $75ea841c346a0052$var$InputNumber.var.step;
        if ($75ea841c346a0052$var$InputNumber.var.min <= newValue) {
            $input.val(newValue);
            $input.trigger("change");
        }
    },
    makeDom: ()=>{
        for(let index = 0; index < $75ea841c346a0052$var$$('.quantity input[type="number"]').length; index++){
            const $inputWrapper = $75ea841c346a0052$var$$('<div class="input-wrapper" />');
            const $this = $75ea841c346a0052$var$$($75ea841c346a0052$var$$('input[type="number"]')[index]);
            let $plus, $minus;
            if ($this.closest(".shop-pages").length > 0) {
                $plus = $75ea841c346a0052$var$$('<span class="arrow-up icon">+</span>');
                $minus = $75ea841c346a0052$var$$('<span class="arrow-down icon">-</span>');
            } else {
                $plus = $75ea841c346a0052$var$$('<svg class="arrow-up" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.23466 4.71935C9.27523 4.75885 9.30748 4.80608 9.32949 4.85825L9.23736 4.89713L9.3295 4.85825C9.35151 4.91042 9.36286 4.96647 9.36286 5.02309C9.36286 5.07971 9.35151 5.13576 9.3295 5.18793L9.23736 5.14905C9.22054 5.18891 9.1959 5.225 9.1649 5.25518L9.23478 5.32671C9.23474 5.32675 9.2347 5.32679 9.23466 5.32683C9.15242 5.40711 9.04204 5.45205 8.92711 5.45205C8.81213 5.45205 8.7017 5.40707 8.61945 5.32671L8.58933 5.29729V5.29664L5.13106 1.92556L1.64268 5.326L1.5728 5.25447L1.6426 5.32608L1.64265 5.32603C1.5604 5.40636 1.44999 5.45134 1.33501 5.45134C1.22003 5.45134 1.1096 5.40635 1.02735 5.326L1.02724 5.3259C0.986956 5.28643 0.954952 5.23931 0.933103 5.18732C0.911254 5.13532 0.9 5.07949 0.9 5.02309C0.9 4.96669 0.911254 4.91086 0.933103 4.85886C0.954951 4.80687 0.986956 4.75975 1.02724 4.72028L1.02742 4.72011L4.81279 1.02943L4.8128 1.02942C4.89795 0.946419 5.01215 0.899967 5.13106 0.899967C5.24997 0.899967 5.36418 0.946419 5.44933 1.02942L5.44933 1.02942L9.23466 4.71935ZM9.23466 4.71935L9.1649 4.791L9.2347 4.71939L9.23466 4.71935Z" fill="#513933" stroke="#513933" stroke-width="0.2"/></svg>');
                $minus = $75ea841c346a0052$var$$('<svg class="arrow-down" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.23466 1.6327C9.27523 1.5932 9.30748 1.54597 9.32949 1.4938L9.23736 1.45492L9.3295 1.4938C9.35151 1.44163 9.36286 1.38558 9.36286 1.32896C9.36286 1.27234 9.35151 1.21629 9.3295 1.16412L9.23736 1.203C9.22054 1.16314 9.1959 1.12705 9.1649 1.09687L9.23478 1.02534C9.23474 1.0253 9.2347 1.02526 9.23466 1.02522C9.15242 0.944942 9.04204 0.9 8.92711 0.9C8.81213 0.9 8.7017 0.944985 8.61945 1.02534L8.58933 1.05476V1.05541L5.13106 4.42649L1.64268 1.02605L1.5728 1.09758L1.6426 1.02597L1.64265 1.02602C1.5604 0.945687 1.44999 0.900712 1.33501 0.900712C1.22003 0.900712 1.1096 0.945697 1.02735 1.02605L1.02724 1.02615C0.986956 1.06562 0.954952 1.11274 0.933103 1.16473C0.911254 1.21673 0.9 1.27256 0.9 1.32896C0.9 1.38536 0.911254 1.44119 0.933103 1.49319C0.954951 1.54518 0.986956 1.5923 1.02724 1.63177L1.02742 1.63194L4.81279 5.32262L4.8128 5.32263C4.89795 5.40563 5.01215 5.45208 5.13106 5.45208C5.24997 5.45208 5.36418 5.40563 5.44933 5.32263L5.44933 5.32263L9.23466 1.6327ZM9.23466 1.6327L9.1649 1.56105L9.2347 1.63266L9.23466 1.6327Z" fill="#513933" stroke="#513933" stroke-width="0.2"/></svg>');
            }
            if ($this.attr("min") && $this.attr("min") !== "") $75ea841c346a0052$var$InputNumber.var.min = parseFloat($this.attr("min"));
            if ($this.attr("max") && $this.attr("max") !== "") $75ea841c346a0052$var$InputNumber.var.max = parseFloat($this.attr("max"));
            if ($this.attr("step") && $this.attr("step") !== "") $75ea841c346a0052$var$InputNumber.var.step = parseFloat($this.attr("step"));
            $this.wrapAll($inputWrapper);
            const $parent = $this.parent();
            $parent.append($plus);
            $parent.append($minus);
            $plus.on("click", ()=>{
                $75ea841c346a0052$var$InputNumber.increase($this);
            });
            $minus.on("click", ()=>{
                $75ea841c346a0052$var$InputNumber.decrease($this);
            });
        }
    },
    init: function() {
        $75ea841c346a0052$var$InputNumber.makeDom();
        $75ea841c346a0052$var$$("body").on("updated_wc_div", function() {
            $75ea841c346a0052$var$InputNumber.makeDom();
        });
    }
};
var $75ea841c346a0052$export$2e2bcd8739ae039 = $75ea841c346a0052$var$InputNumber;


const $19fedfa96cd87c1c$var$$ = jQuery;
const $19fedfa96cd87c1c$var$ShareProduct = {
    init: function() {
        this.shareButton = $19fedfa96cd87c1c$var$$(".single-product-share");
        this.shareLinks = $19fedfa96cd87c1c$var$$(".single-product-share-links");
        this.setupClickListener();
        this.setupOutsideClickListener();
    },
    setupClickListener: function() {
        this.shareButton.on("click", (function(event) {
            event.preventDefault();
            this.toggleShareLinks();
        }).bind(this));
    },
    setupOutsideClickListener: function() {
        $19fedfa96cd87c1c$var$$(document).on("click", (function(event) {
            if (!this.shareButton.is(event.target) && !this.shareButton.has(event.target).length && !this.shareLinks.is(event.target) && !this.shareLinks.has(event.target).length) this.shareLinks.slideUp();
        }).bind(this));
    },
    toggleShareLinks: function() {
        this.shareLinks.slideToggle();
    }
};
var $19fedfa96cd87c1c$export$2e2bcd8739ae039 = $19fedfa96cd87c1c$var$ShareProduct;


const $cc7923cc3d4263e7$var$$ = jQuery;
const $cc7923cc3d4263e7$var$ShowMore = {
    init: ()=>{
        const filters = document.querySelector(".blog .posts-wrapper");
        if (!filters) return;
        const tags = document.querySelectorAll(".post-item");
        const html = `<div class="show-wrapper"><div class="container"><p class="btn show-more-btn btn-transparent">Load More</p></div></div>`;
        filters.insertAdjacentHTML("beforeend", html);
        const showMore = document.querySelector(".show-more-btn");
        tags.forEach((tag, index)=>{
            if (index <= 4) tag.classList.add("active");
        });
        let currentVisibleIndex = 4;
        showMore.addEventListener("click", ()=>{
            if (showMore.textContent === "Load More") {
                let newLimit = tags.length - 1;
                tags.forEach((tag, index)=>{
                    if (index <= newLimit) tag.classList.add("active");
                });
                currentVisibleIndex = newLimit;
                if (currentVisibleIndex >= tags.length - 1) showMore.textContent = "Load Less";
            } else {
                tags.forEach((tag, index)=>{
                    if (index > 4) tag.classList.remove("active");
                });
                currentVisibleIndex = 4;
                showMore.textContent = "Load More";
            }
        });
    }
};
var $cc7923cc3d4263e7$export$2e2bcd8739ae039 = $cc7923cc3d4263e7$var$ShowMore;


const $e95d65fadb8dbc21$var$$ = jQuery;
const $e95d65fadb8dbc21$var$HoverMenu = {
    init: function() {
        this.menuItem = $e95d65fadb8dbc21$var$$(".custom-cart-icon");
        this.subMenu = $e95d65fadb8dbc21$var$$(".cart-hover-content");
        this.closeIcon = $e95d65fadb8dbc21$var$$(".close-icon");
        this.setupEventListeners();
    },
    setupEventListeners: function() {
        this.menuItem.on("click", this.handleMenuClick.bind(this));
        this.closeIcon.on("click", this.handleCloseClick.bind(this));
        this.subMenu.on("click", function(event) {
            event.stopPropagation();
        });
        $e95d65fadb8dbc21$var$$(document).on("click", (event)=>{
            if (!this.menuItem.is(event.target) && !this.menuItem.has(event.target).length && !this.subMenu.is(event.target) && !this.subMenu.has(event.target).length) this.hideSubMenu();
        });
    },
    handleMenuClick: function(event) {
        event.preventDefault();
        this.toggleSubMenu();
    },
    handleCloseClick: function(event) {
        event.stopPropagation();
        this.hideSubMenu();
    },
    toggleSubMenu: function() {
        if (this.subMenu.is(":visible")) this.hideSubMenu();
        else this.showSubMenu();
    },
    showSubMenu: function() {
        this.subMenu.stop(true, true).slideDown();
        $e95d65fadb8dbc21$var$$("body").addClass("cart-open");
    },
    hideSubMenu: function() {
        this.subMenu.stop(true, true).slideUp();
        $e95d65fadb8dbc21$var$$("body").removeClass("cart-open");
    }
};
var $e95d65fadb8dbc21$export$2e2bcd8739ae039 = $e95d65fadb8dbc21$var$HoverMenu;


const $a6dca10a9bc73c06$var$$ = jQuery;
const $a6dca10a9bc73c06$var$CartUpdate = {
    init: function() {
        this.setupEventListeners();
    },
    setupEventListeners: function() {
        this.setupCartQuantityChange();
        this.setupFormSubmit();
        this.replaceCartFormIfNeeded();
    },
    setupCartQuantityChange: function() {
        $a6dca10a9bc73c06$var$$(document).on("input change", '.woocommerce-cart-form :input[name^="cart["][name$="][qty]"]', ()=>{
            $a6dca10a9bc73c06$var$$('[name="update_cart"]').prop("disabled", false);
        });
    },
    setupFormSubmit: function() {
        $a6dca10a9bc73c06$var$$(".woocommerce-cart-form").on("submit", (e)=>{
            if ($a6dca10a9bc73c06$var$$('[name="update_cart"]').prop("disabled") === false) return true;
            else e.preventDefault();
        });
    },
    replaceCartFormIfNeeded: function() {
        const $new_form = $a6dca10a9bc73c06$var$$("#new_cart_form");
        if ($new_form.length) {
            $a6dca10a9bc73c06$var$$(".woocommerce-cart-form").replaceWith($new_form);
            $new_form.find(':input[name="update_cart"]').prop("disabled", true);
            this.setupEventListeners();
        }
    }
};
var $a6dca10a9bc73c06$export$2e2bcd8739ae039 = $a6dca10a9bc73c06$var$CartUpdate;


const $2f817d40ed3d8553$var$$ = jQuery;
const $2f817d40ed3d8553$var$LoginRegisterToggle = {
    init: function() {
        const loginForm = $2f817d40ed3d8553$var$$('#customer_login .u-column1');
        const registerForm = $2f817d40ed3d8553$var$$('#customer_login .u-column2');
        const toggleRegisterButton = $2f817d40ed3d8553$var$$('#show-register');
        const toggleLoginButton = $2f817d40ed3d8553$var$$('#show-login');
        if (loginForm.length && registerForm.length) {
            loginForm.addClass('active');
            toggleRegisterButton.on('click', ()=>{
                loginForm.removeClass('active');
                registerForm.addClass('active');
                $2f817d40ed3d8553$var$$('.toggle-register').hide();
                $2f817d40ed3d8553$var$$('.toggle-login').show();
            });
            toggleLoginButton.on('click', ()=>{
                registerForm.removeClass('active');
                loginForm.addClass('active');
                $2f817d40ed3d8553$var$$('.toggle-register').show();
                $2f817d40ed3d8553$var$$('.toggle-login').hide();
            });
        }
    }
};
var $2f817d40ed3d8553$export$2e2bcd8739ae039 = $2f817d40ed3d8553$var$LoginRegisterToggle;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $538ea2323a48fb5c$export$2e2bcd8739ae039).init();
(0, $8bae1bbaa0bec04d$export$2e2bcd8739ae039).init();
(0, $746bb6da1b444b48$export$2e2bcd8739ae039).init();
(0, $75ea841c346a0052$export$2e2bcd8739ae039).init();
(0, $19fedfa96cd87c1c$export$2e2bcd8739ae039).init();
(0, $cc7923cc3d4263e7$export$2e2bcd8739ae039).init();
(0, $e95d65fadb8dbc21$export$2e2bcd8739ae039).init();
(0, $a6dca10a9bc73c06$export$2e2bcd8739ae039).init();
(0, $2f817d40ed3d8553$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
